import { render, staticRenderFns } from "./StateAnswerPublished.vue?vue&type=template&id=b039185e&scoped=true&lang=html&"
import script from "./StateAnswerPublished.vue?vue&type=script&lang=coffee&"
export * from "./StateAnswerPublished.vue?vue&type=script&lang=coffee&"
import style0 from "./StateAnswerPublished.vue?vue&type=style&index=0&id=b039185e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b039185e",
  null
  
)

component.options.__file = "StateAnswerPublished.vue"
export default component.exports